export default "__VITE_ASSET__800f586f__"